module.exports = __webpack_public_path__ + "static/media/1991_Population_totalRate.476e2d61.png";